// extracted by mini-css-extract-plugin
module.exports = {"container":"container--2omC1","text-container":"text-container--3GtMF","current-step":"current-step--1N2Ts","next-text":"next-text--3C0E7","next-step":"next-step--1M8IJ"};